export const MAP_PIN_HEIGHT_PX = 45;

export const MAP_PIN_PRIMARY_HEIGHT_PX = MAP_PIN_HEIGHT_PX;
export const MAP_PIN_PRIMARY_WIDTH_PX = MAP_PIN_HEIGHT_PX;

export const MAP_PIN_SECONDARY_HEIGHT_PX = MAP_PIN_HEIGHT_PX;
export const MAP_PIN_SECONDARY_WIDTH_PX = 33;

export const MAP_PIN_PRIMARY = 'primary';
export const MAP_PIN_SECONDARY = 'secondary';

export const MAP_PIN_TYPE_ALPHA = 'alpha';
export const MAP_PIN_TYPE_BLANK = 'blank';
export const MAP_PIN_TYPE_NUMERIC = 'numeric';
export const MAP_PIN_TYPE_DEFAULT = MAP_PIN_TYPE_BLANK;

export const MAP_PIN_FALLBACK_COLOR = '#4a4a4a';

export const MAP_PIN_TYPES = [
  MAP_PIN_TYPE_ALPHA,
  MAP_PIN_TYPE_BLANK,
  MAP_PIN_TYPE_NUMERIC,
];

export const MAP_PIN_TYPES_SOLID = [
  MAP_PIN_TYPE_ALPHA,
  MAP_PIN_TYPE_NUMERIC,
];
